import React from 'react';
import { Icon } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import * as S from './KitConnected.styled';
// type Props = {
//   createSyncJob: () => Promise<void>
//   isCreatingSyncJob: boolean
//   hasSynced: boolean
//   recentSync: boolean
// }
export const KitConnected = () => {
    // const handleCreateSyncJob = async () => {
    //   try {
    //     await createSyncJob()
    //   } catch (error) {
    //     Toasts.notify('Failed to start Kit sync. Please try again.', { type: 'error' })
    //     console.error('Failed to create Kit sync job:', error)
    //   }
    // }
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null,
            React.createElement(Icon, { component: TickIcon, width: 24, height: 24 }),
            React.createElement("div", null, "Successfully Connected to Kit")),
        React.createElement(S.Description, null, "Your Fourthwall shop is now connected to Kit. You can now sync your supporter data and create powerful email marketing campaigns to engage with your community.")));
};
